import React, { ReactElement } from 'react';
import cn from 'classnames';
import { Box, SxProps, Theme } from '@mui/material';
import Actions from './actions/actions';
import styles from './styles';
import { ActionsType } from './types';
import useIsMobile from 'hooks/useIsMobile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GalleryDivider } from './galleryDivider';
import { useGalleryContext } from '.';
import { formatTranslation } from 'intl';
import { DocumentationTranslationKeys } from 'intl/keys';
import { useIntl } from 'react-intl';
import { CurrentVersionNumber } from 'components/documentation/CurrentVersionNumber';

const currentVersionNumberSx: SxProps<Theme> = { ml: 1.5, display: 'inline-flex', flexShrink: 0 };

export function TopBar(props: {
  onCloseClick: () => void;
  actions: ActionsType;
  idx: number;
  setDrawMode: (bool: boolean) => void;
  disableActions: boolean;
  preview?: boolean;
}): ReactElement {
  const { actions, idx, onCloseClick, setDrawMode, disableActions } =
    props;

  const intl = useIntl();
  const isMobile = useIsMobile();
  const cs = styles({ isMobile });
  const { useMainDisplayedFile, EditComponent, editTitleId } =
    useGalleryContext();
  const [file] = useMainDisplayedFile((mainFile) => mainFile);
  const title = file?.title || '';
  const currentVersionNumber = file?.currentVersionNumber;
  const isArchived =
    file?.deleted === true ||
    Boolean((file?.data as { deleted?: boolean } | undefined)?.deleted);
  const mapStateLabel = isArchived
    ? formatTranslation(intl, DocumentationTranslationKeys.stateWithdrawn).toLocaleLowerCase()
    : '';

  return (
    <div className={cs.topBarContainer}>
      <div className={cs.topBar}>
        <button
          className={cn(cs.textButton, cs.topElement)}
          onClick={onCloseClick}
        >
          <ArrowBackIcon />
          <Box
            component='p'
            className={cs.title}
            sx={{ display: 'flex', alignItems: 'center', overflow: 'visible' }}
          >
            <Box
              component='span'
              sx={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                minWidth: 0,
              }}
            >
              {title}
            </Box>
            {currentVersionNumber !== undefined ? (
              <Box component='span' sx={currentVersionNumberSx}>
                <CurrentVersionNumber number={currentVersionNumber} onDark />
              </Box>
            ) : null}
            {mapStateLabel ? (
              <Box
                component='span'
                sx={{ color: 'grey.500', ml: 1, fontWeight: 'normal' }}
              >
                ({mapStateLabel})
              </Box>
            ) : null}
          </Box>
        </button>
        <Actions
          actions={actions}
          idx={idx}
          setDrawMode={setDrawMode}
          disabled={disableActions}
          EditComponent={EditComponent}
          titleId={editTitleId}
        />
      </div>
      <GalleryDivider />
    </div>
  );
}
